import React from 'react';

interface FooterProps {
  /** Narrow standalone pages (e.g. profile-update) — no viewport-wide `container`. */
  compact?: boolean;
}

export const Footer: React.FC<FooterProps> = ({ compact = false }) => {
  return (
    <footer className="w-full max-w-full box-border py-4 px-4 sm:px-6 border-t border-dark-border bg-dark-card/50 text-center">
      <div
        className={
          compact
            ? 'mx-auto flex max-w-full flex-col flex-wrap items-center justify-center gap-x-4 gap-y-2 sm:flex-row'
            : 'container mx-auto flex flex-col md:flex-row justify-center items-center gap-4'
        }
      >
        <span className="text-xs text-dark-text-secondary">
          © {new Date().getFullYear()} TalentFirst. All rights reserved.
        </span>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="/privacy-policy"
            className="text-xs text-blue-400 hover:text-blue-300 transition-colors"
          >
            Privacy Policy
          </a>
          <span className="text-gray-600 text-xs">·</span>
          <a
            href="mailto:support@talentfirst.com"
            className="text-xs text-dark-text-secondary hover:text-dark-text transition-colors"
          >
            Support
          </a>
        </div>
      </div>
    </footer>
  );
};
